import React from 'react'
import { Button } from '../components/button'
import { Input } from '../components/input'
import { PasswordInput } from '../components/password-input'
import { CurrencyInputField } from '../components/currency-input-field'
import { Spinner } from '../components/spinner'
import { Logo } from '../components/logo'
import { Sidebar } from '../components/sidebar'
import { AuthLayout } from 'src/components/auth-layout'
import { Layout } from './layout'
import { Container } from 'src/components/container'

const ComponentPreview = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="mb-4 text-2xl font-bold">Component Preview</h1>

      <div className="mb-8">
        <h2 className="mb-2 text-xl font-semibold">Buttons</h2>
        <div className="flex space-x-4">
          <Button variant="primary">Primary Button</Button>
          <Button variant="secondary">Secondary Button</Button>
          <Button variant="danger">Danger Button</Button>
        </div>
      </div>

      <div className="mb-8">
        <h2 className="mb-2 text-xl font-semibold">Inputs</h2>
        <div className="space-y-4">
          <Input label="Standard Input" placeholder="Enter text here" />
          <PasswordInput label="Password Input" placeholder="Enter password" />
          <CurrencyInputField
            label="Currency Input"
            currency="USD"
            value={100}
            onValueChange={() => console.log()}
            onCurrencyChange={() => console.log()}
          />
        </div>
      </div>

      <div className="mb-8">
        <h2 className="mb-2 text-xl font-semibold">Spinner</h2>
        <Spinner size="lg" />
      </div>

      <div className="mb-8">
        <h2 className="mb-2 text-xl font-semibold">Logo</h2>
        <Logo />
      </div>

      <div className="mb-8">
        <h2 className="mb-2 text-xl font-semibold">Sidebar</h2>
        <Sidebar />
      </div>

      <div className="mb-8">
        <h2 className="mb-2 text-xl font-semibold">Layout</h2>
        <div className="relative h-64 w-full rounded-lg border">
          <Layout />
          <Container>
            <div className="p-4">This is the main content area</div>
          </Container>
        </div>
      </div>

      <div className="mb-8">
        <h2 className="mb-2 text-xl font-semibold">Auth Layout</h2>
        <div className="relative h-64 w-full rounded-lg border">
          <AuthLayout title="Auth Layout Title">
            <div className="p-4">This is the auth content area</div>
          </AuthLayout>
        </div>
      </div>
    </div>
  )
}

export default ComponentPreview
